// extracted by mini-css-extract-plugin
module.exports = {"container":"ResultsPage_container__1-sc5","resultsContainer":"ResultsPage_resultsContainer__2KIKU","result":"ResultsPage_result__XjBma"};